// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24tbb","col":"styles_col__2vK_y"};